import type { ComponentCommonEmbedded } from '@edwin-group/cj-graphql/generated/graphql';
import ReactPlayer from 'react-player';
import cn from 'classnames';

import './embedded.css';
import { useState } from 'react';

export default function DefaultContentTemplateEmbedded({
  component,
  fitContent = false,
  className,
  onEnded,
  isDefaultContentTemplate = false,
  onVideoPlay,
  onDuration = () => {},
}: {
  component: ComponentCommonEmbedded;
  fitContent?: boolean;
  className?: string;
  onEnded?: (totalWatchedDuration: number) => void;
  isDefaultContentTemplate?: boolean;
  onVideoPlay?: () => void;
  onDuration?: (n: number) => void;
}) {
  const [watchStartTime, setWatchStartTime] = useState<number | null>(null);

  const handlePlay = () => {
    onVideoPlay && onVideoPlay();
    setWatchStartTime(new Date().getTime());
  };

  const handlePause = () => {
    if (!watchStartTime) return;
  };

  const handleEnded = () => {
    if (!watchStartTime) return;
    const totalWatchedDuration = (Date.now() - watchStartTime) / 1000;
    if (onEnded) {
      onEnded(Math.round(totalWatchedDuration));
    }
  };

  return (
    <>
      <div
        className={cn(
          'player-wrapper flex justify-center',
          {
            'lg:-mx-[12%]': !fitContent,
            'my-0': isDefaultContentTemplate,
            'my-sh-30': !isDefaultContentTemplate,
          },
          className,
        )}
        key={component.id}>
        <ReactPlayer
          config={{
            youtube: {
              playerVars: { showinfo: 1, rel: 0 },
              embedOptions: { rel: 0 },
            },
          }}
          className="react-player"
          key={component.id}
          width="100%"
          height="100%"
          controls={true}
          onPlay={handlePlay}
          onPause={handlePause}
          onEnded={handleEnded}
          onDuration={onDuration}
          url={component?.link}
        />
      </div>
    </>
  );
}
